import React, { ReactNode } from "react";
import { Skeleton, Space, Tooltip, Typography } from "antd";

const { Text } = Typography;

export interface KPIItem {
	key: string;
	icon: ReactNode;
	label: string;
	value: number;
	color: string;
	alert?: boolean;
}

interface DashboardKPIStripProps {
	kpis: KPIItem[];
}

const DashboardKPIStrip: React.FC<DashboardKPIStripProps> = ({ kpis }) => {
	if (!kpis.length) return null;

	return (
		<Space size={10} wrap align="center">
			{kpis.map((kpi, idx) => (
				<React.Fragment key={kpi.key}>
					{idx > 0 && (
						<span style={{ color: "var(--mg-border)", userSelect: "none", lineHeight: 1 }}>·</span>
					)}
					<Tooltip title={kpi.label} mouseEnterDelay={0.3}>
						<Space size={4} align="center" style={{ cursor: "default" }}>
							<span
								style={{
									color: kpi.alert ? "var(--mg-danger)" : kpi.color,
									fontSize: 14,
									lineHeight: 1,
									display: "inline-flex",
								}}
							>
								{kpi.icon}
							</span>
							<Text
								style={{
									fontSize: 13,
									fontWeight: 600,
									lineHeight: 1,
									color: kpi.alert ? "var(--mg-danger)" : undefined,
								}}
							>
								{kpi.value}
							</Text>
						</Space>
					</Tooltip>
				</React.Fragment>
			))}
		</Space>
	);
};

export const KPIStripSkeleton: React.FC<{ count?: number }> = ({ count = 5 }) => (
	<Space size={6}>
		{Array.from({ length: count }).map((_, i) => (
			<Skeleton.Input key={i} active size="small" style={{ width: 40, height: 20, borderRadius: 4 }} />
		))}
	</Space>
);

export default DashboardKPIStrip;
